import React, { useEffect, useCallback, useContext, useState } from "react";
import { useParams, useLocation } from "react-router";

import TopHeader from "./header";
import "./style.scss";
import Stepper from "./stepper";
import SelectCharges from "./selectCharges";
import {
  breakResponseIntoParts,
  handleStripMessages,
  isAccessOfCollection,
  steps,
  studentData,
} from "./utils";
import {
  CollectPaymentModuleProvider,
  useGetCollectPaymentContext,
} from "./context";
import CustomLoader from "../../common/commonComponents/Loader/loader";
import { getChargesByApplicationId } from "./apis";
import PopupAlert from "./alertMessages/PopupAlert";
import TopStripAlert from "./alertMessages/TopStripAlert";
import { UserDetails } from "appContext";
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../common/constant";
import SelectPaymentModeWrapper from "./selectPaymentMode";
import ReviewAndReceipt from "./reviewAndReceipt";
import { otherCharges } from "./context/constants";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import PermissionWrapper from "./PermissionWrapper";
import { PermisionDenied } from "../../common/commonComponents";
import StepperWrapper from "./stepper/StepperWrapper";
const getDropdowns = async () => {
  const dropdown = await Promise.all([
    dropdownMapping(
      endpoint.businessArea.getAllActiveV2,
      "businessAreaDispValue",
      "id"
    ),
  ]);
  return dropdown[0];
};

export const pageStateMapping = {
  SELECT_CHARGES: <SelectCharges />,
  SELECT_PAYMENT_MODE: <SelectPaymentModeWrapper />,
  REVIEW: <ReviewAndReceipt />,
};

const GetPageComponentByState = ({ applicationId }) => {
  const {
    currentPageState,
    setApplicationId,
    setStudentBasicDetails,
    setStudentCharges,
    setChargesListFetching,
    isChargesListFetching,
    setRoleId,
    setAlertPopup,
    setFreezeAllCheckboxes,
    setFreezeRegularChargesCheckboxes,
    setTopStrip,
    studentChargesList,
    setTotalUnpaidAmount,
    setState,
    state,
  } = useGetCollectPaymentContext();
  const data = useContext(UserDetails);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigatedFrom = queryParams.get("from");

  const fetchCharges = useCallback(async () => {
    try {
      setChargesListFetching(true);
      const res = await getChargesByApplicationId(applicationId, state);
      const response = res?.data;
      if (response?.code !== 200 || !response?.data) {
        setChargesListFetching(false);
        return;
      }
      if (res?.code === 412) {
        window.location.reload();
        return;
      }

      const { regularCharges, otherCharges, studentDetails } =
        breakResponseIntoParts(response.data);
      setState(res?.state);

      setStudentBasicDetails(studentDetails);
      setStudentCharges({
        REGULAR_CHARGES: regularCharges,
        OTHER_CHARGES: otherCharges,
      });
      // Handle alert popup based on validation success and payment collection block
      const hasErrorMessage = studentDetails?.popUpMessageList?.[0]?.messageType === "ERROR_MESSAGE";
      if (studentDetails?.popUpMessageList && (!studentDetails?.lumpSumType || hasErrorMessage)) {
        const alertDetails = {
          isOpen: true,
          ...studentDetails?.popUpMessageList[0],
          isPaymentCollectionBlocked:
            studentDetails?.isPaymentCollectionBlocked,
          isFromEpmr: navigatedFrom ? true : false,
        };
        setAlertPopup(alertDetails);
      }

      // Configure top strip message if payment mode is JODO
      if (response?.data?.isPaymentModeJODO)
        handleStripMessages(response?.data?.headerMessageList, setTopStrip);

      // Freeze checkboxes based on student details
      const freezeCharges = studentDetails?.freezeAllCharges;
      setFreezeAllCheckboxes(
        !!freezeCharges || studentDetails?.isPaymentCollectionBlocked
      );

      setFreezeRegularChargesCheckboxes(freezeCharges === false);

      setChargesListFetching(false);
    } catch (error) {
      console.error("Failed to fetch charges", error);
      setChargesListFetching(false);
    }
  }, [applicationId, setStudentBasicDetails, setStudentCharges]);

  useEffect(() => {
    setApplicationId(applicationId);
    fetchCharges();
  }, [applicationId, setApplicationId, fetchCharges]);

  useEffect(() => {
    const fetchDetails = async () => {
      const details = await fetchAllPromisedData(
        `${endpoint.getUserByEmployeeId}/${data?.employeeId}`,
        true
      );
      if (details && details?.code == 200) {
        const roleId = await details?.data?.userIdProjectRoleDtoList
          .map((item) => {
            return item?.roleInformationDtoList.map((i) => {
              return i?.roleId;
            });
          })
          .flat();
        setRoleId(roleId);
      }
    };
    data && fetchDetails();
  }, [data]);
  useEffect(() => {
    const regularUnpaidAmount = studentChargesList?.["REGULAR_CHARGES"]
      ? studentChargesList["REGULAR_CHARGES"].reduce((sum, item) => {
          return sum + item?.totalBalanceAmount;
        }, 0) ?? 0
      : 0;
    const otherUnpaidAmount = studentChargesList?.["REGULAR_CHARGES"]
      ? studentChargesList["OTHER_CHARGES"].reduce((sum, item) => {
          return sum + item?.totalBalanceAmount;
        }, 0) ?? 0
      : 0;
    setTotalUnpaidAmount(Number(regularUnpaidAmount + otherUnpaidAmount));
  }, [studentChargesList]);

  return isChargesListFetching ? (
    <CustomLoader
      apiLoader={isChargesListFetching}
      loaderHeight={"200px"}
      loaderWidth={"100% "}
    />
  ) : (
    pageStateMapping[currentPageState] || null
  );
};

const CollectPayment = ({ match }) => {
  const { applicationId } = match.params;
  const [allActiveBu, setAllActiveBu] = useState([]);

  useEffect(() => {
    getDropdowns().then((res) => setAllActiveBu(res));
  }, []);

  return (
    <CollectPaymentModuleProvider>
      <PermissionWrapper>
        <>
          <div className="remove-container-top-space">
            <TopHeader studentData={studentData} />
            <div className="p-2 m-2">
              <StepperWrapper/>
              <TopStripAlert />
              <GetPageComponentByState applicationId={applicationId} />
            </div>
          </div>
          <PopupAlert />
        </>
      </PermissionWrapper>
    </CollectPaymentModuleProvider>
  );
};

export default CollectPayment;
